import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnlink = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.8125 3.59375C2.43954 3.59375 2.08185 3.74191 1.81813 4.00563C1.55441 4.26935 1.40625 4.62704 1.40625 5C1.40625 5.37296 1.55441 5.73065 1.81813 5.99437C2.08185 6.25809 2.43954 6.40625 2.8125 6.40625H3.91914C4.17802 6.40625 4.38789 6.61612 4.38789 6.875C4.38789 7.13388 4.17802 7.34375 3.91914 7.34375H2.8125C2.1909 7.34375 1.59476 7.09682 1.15522 6.65728C0.71568 6.21774 0.46875 5.6216 0.46875 5C0.46875 4.3784 0.71568 3.78226 1.15522 3.34272C1.59476 2.90318 2.1909 2.65625 2.8125 2.65625H3.89473C4.15361 2.65625 4.36348 2.86612 4.36348 3.125C4.36348 3.38388 4.15361 3.59375 3.89473 3.59375H2.8125Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.63647 3.125C5.63647 2.86612 5.84634 2.65625 6.10522 2.65625H7.18745C7.80905 2.65625 8.40519 2.90318 8.84473 3.34272C9.28427 3.78226 9.5312 4.3784 9.5312 5C9.5312 5.6216 9.28427 6.21774 8.84473 6.65728C8.40519 7.09682 7.80905 7.34375 7.18745 7.34375H6.08081C5.82193 7.34375 5.61206 7.13388 5.61206 6.875C5.61206 6.61612 5.82193 6.40625 6.08081 6.40625H7.18745C7.56041 6.40625 7.9181 6.25809 8.18182 5.99437C8.44554 5.73065 8.5937 5.37296 8.5937 5C8.5937 4.62704 8.44554 4.26935 8.18182 4.00563C7.9181 3.74191 7.56041 3.59375 7.18745 3.59375H6.10522C5.84634 3.59375 5.63647 3.38388 5.63647 3.125Z",
		fill: "white"
	})]
});
export default SvgUnlink;
